//import { vendorList } from '@/services/Vendors/store'

export const methods = {
  async reload() {
    this.loading = true

    this.workOrderID = this.$route.params.id || 0

    this.loading = false
  },

  returnToParent() {
    this.$router.push({
      name: 'workOrders'
    })
  }
}
